<template>
  <div class="page">
    <h1>Page Not Found</h1>
    <p class="description-text">Sorry. We couldn't find that page.</p>
  </div>
</template>

<style lang="scss" scoped></style>

<script>
export default {
  name: 'NotFound404Page',
};
</script>
